import { render, staticRenderFns } from "./PneumoniaVaccine.vue?vue&type=template&id=bf4a88ba&scoped=true"
import script from "./PneumoniaVaccine.vue?vue&type=script&lang=js"
export * from "./PneumoniaVaccine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4a88ba",
  null
  
)

export default component.exports